export default __webpack_public_path__ + "static/media/phone.ab41c8b4.svg";